import { writable } from "svelte/store"

const initLoc = {
    path: (typeof window !== "undefined" && window.location?.pathname) || "/",
    search: (typeof window !== "undefined" && window.location?.search) || "",
    hash: (typeof window !== "undefined" && window.location?.hash) || "",
    push: false,
    pop: false,
    categoryPath: "",
}
export const location = writable(initLoc)

export let navigation = writable<Navigation>()
export let sites = writable<Sites>({})
export let serviceNavigation = writable<Navigation>()
export let banner = writable<Banner[]>([])
export let temperature = writable<Temperature>()
